import React from 'react';
import {useIntl} from "react-intl";
import {StyledFieldDatepicker}  from "../../../FieldDatepicker";
import {StyledFieldSelect} from "../../../FieldSelect";
import {optionsTaskStatus} from "../../../../../CustomerDetails/constants/options";
import {shallowEqual, useSelector} from "react-redux";
import {filterOptions} from "../../../../utils/options";
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import {StyledFieldTextareaAutosize} from "../../../FieldTextareaAutosize";
import {getFieldLabel} from '../../utils/getFieldLabel';
import ModalHeader from '../../../ModalHeader';
import ModalContent from '../../../ModalContent';

export function TaskGeneral({header}) {
  const intl = useIntl();
  const {formik, fieldNames} = useTaskAndNotesGridContext();
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);

  return (
    <>
      <ModalHeader header={header}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldTextareaAutosize
          fieldId={fieldNames.taskDescription}
          onChange={(e) => formik.setFieldValue(fieldNames.taskDescription, e.target.value)}
          value={formik.values[fieldNames.taskDescription]}
          label={getFieldLabel(intl.formatMessage({id: 'tab-order-inspections-tasks-popup-taskDescription', defaultMessage: 'Task description'}))}
          customContainerStyles={'py-3'}
          customLabelStyles={'fs-6'}
          maxRows={6}
        />
        <StyledFieldSelect
          fieldId={fieldNames.responsibleUserID}
          onChange={(option) => formik.setFieldValue(fieldNames.responsibleUserID, option.value)}
          value={filterOptions(formik.values.responsibleUserID)(users)}
          options={users}
          label={getFieldLabel(intl.formatMessage({id: 'tab-order-inspections-tasks-popup-responsibleUser', defaultMessage: 'Responsible user'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldDatepicker
          value={formik.values.taskDueDate}
          onChange={(date) => {
            formik.setFieldValue(fieldNames.taskDueDate, new Date(date));
          }}
          label={getFieldLabel(intl.formatMessage({id: 'tab-order-inspections-tasks-popup-dueDate', defaultMessage: 'Due date'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldSelect
          fieldId={fieldNames.taskStatusID}
          onChange={(option) => formik.setFieldValue(fieldNames.taskStatusID, option.value)}
          value={filterOptions(formik.values.taskStatusID)(optionsTaskStatus)}
          options={optionsTaskStatus}
          label={getFieldLabel(intl.formatMessage({id: 'tab-order-inspections-tasks-popup-status', defaultMessage: 'Status'}))}
          customContainerStyles={'py-3'}
        />
      </ModalContent>
    </>
  );
}